import React from 'react';
import Boton from './Boton';
import './css/Modal.css';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  componentDidMount(){}

  render(){
    const {titulo, children, loading, botonera} = this.props;
    if (loading) {
      return(
        <div className="Modal" style={{paddingTop:70}}>
          <div className="Container" style={{width:'70%'}}>
            <div className="Formulario" style={{width:'100%'}}>
              <h2 style={{textAlign:'center'}}>{titulo}</h2>
              <h4 style={{textAlign:'center'}}><i>Cargando...</i></h4>
            </div>
          </div>
        </div>
      );
    } else {
      return(
        <div className="Modal" style={{paddingTop:70}}>
          <div className="Container" style={{width:'70%'}}>
            <div className="Formulario" style={{width:'100%'}}>
              <h2 style={{textAlign:'center'}}>{titulo}</h2>
              {children}
              {botonera !== undefined && botonera !== null && botonera.length !== 0 &&
                <div
                  style={{
                    display:'flex', flexDirection:'row',
                    position:'relative', alignItems:'center',
                    justifyContent:'center'
                  }}
                >
                  {botonera.map((item, index) => {
                    return(
                      <Boton
                        key={index}
                        backgroundColor={item.backgroundColor}
                        titulo={item.titulo}
                        onClick={() => item.onClick()}
                      />
                    )
                  })}
                </div>
              }
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Modal;

/*
import BaseModal from '../BaseModal';

<BaseModal
  titulo="Seleccionar Persona"
  loading={false}
  botonera={[
    {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => salir()},
    {titulo:"Seleccionar", backgroundColor:'#028D9A', onClick: () => selecionar(seleccionado)}
  ]}
>

</BaseModal>
*/
